const types = {
  SET_CURRENT_INVOICE: 'SET_CURRENT_INVOICE'
};
const state = {
  currentInvoice: null
};

const mutations = {
  [types.SET_CURRENT_INVOICE]: (state, value) => {
    state.currentInvoice = value;
  }
};

const actions = {};
const getters = {};

export default {
  namespaced: true,
  types,
  state,
  mutations,
  actions,
  getters
};
